module.exports = __webpack_public_path__ + "img/messenger-send.2bd2fdc9.svg";